import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  detailsSelector,
  selectIsLoadingUpdateScoringResultStatus,
} from "../../selectors";
import {
  createNegativeMediaIgnoringProperty,
  createWatchListIgnoringProperty,
  updateClientScoringResultStatus,
} from "../../actions";
import {
  setChangeDecisionDetails,
  toggleMQDecisionModal,
} from "../../actions/changeDecisionModalsActions";
import {
  MONITORING_QUEUE_DETAILS_FOR_TYPES,
  MONITORING_QUEUE_ENTRY_TYPES,
  MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES,
} from "../../constants/monitoringQueueEntryConstants";
import { isEmpty, isNil } from "ramda";
import { Col, Container, Row } from "reactstrap";
import MonitoringQueueEntrySearchDetailsForm from "../../components/searching/search-details-form";
import MonitoringQueueEntryScoringDetailsTable from "../../components/scoring/scoring-details-table";
import MonitoringQueueEntryScoringChangeStatusForm from "../../components/scoring/change-status-form";
import MonitoringQueueEntryClientDetailsTable from "../../components/client/client-details-table";
import SaveBeforeExit from "../../../../components/save-before-exit/SaveBeforeExit";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import useRoles from "../../../../components/hooks/useRoles";

const DetailsModalContent = ({ id }) => {
  const dispatch = useDispatch();
  const [permitConfirm, setPermitConfirm] = useState(false);
  const [allHaveDecision, setAllHaveDecision] = useState(undefined);
  const [noneHaveDecision, setNoneHaveDecision] = useState(undefined);
  const [, setDataChange] = useState(false);
  const monitoringQueueEntryDetails = useSelector(detailsSelector);
  const isLoadingUpdateScoringResultStatus = useSelector(
    selectIsLoadingUpdateScoringResultStatus,
  );

  const { isCoordinator } = useRoles();

  useEffect(() => {
    dispatch(setChangeDecisionDetails(null));
    dispatch(toggleMQDecisionModal(false));
  }, [id]);

  const handleUpdateStatus = (data) => {
    const dataObj = data;
    dataObj.clientScoringId =
      monitoringQueueEntryDetails.clientScoringResult.id;
    dispatch(updateClientScoringResultStatus(dataObj));
  };

  const getDetails = (detailsFor) => {
    switch (monitoringQueueEntryDetails.type) {
      case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH: {
        switch (detailsFor) {
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.INPUT_PARAMS:
            return monitoringQueueEntryDetails.clientManualSearchingResult
              .clientManualSearchingParams;
          default:
            return null;
        }
      }
      case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH: {
        const result = monitoringQueueEntryDetails.clientRegularSearchingResult;
        switch (detailsFor) {
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.INPUT_PARAMS:
            return [
              ...result.client.clientParams,
              { categoryTypeList: result.categoryTypeList },
            ];
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.CLIENT:
            return result.client;
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.WATCHLIST_MATCHES_LIST:
            return result.watchListMatchesList;
          default:
            return null;
        }
      }
      case MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING:
      case MONITORING_QUEUE_ENTRY_TYPES.API_SCORING:
      case MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING: {
        const result = monitoringQueueEntryDetails.clientScoringResult;
        switch (detailsFor) {
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.INPUT_PARAMS:
            return result.client.clientParams;
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.CLIENT:
            return result.client;
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.WATCHLIST_MATCHES_LIST:
            return result.watchListMatchesList;
          default:
            return null;
        }
      }
      case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO:
      case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED: {
        switch (detailsFor) {
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.INPUT_PARAMS:
            return monitoringQueueEntryDetails.clientNegativeMediaCheckResult
              .client.clientParams;
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.CLIENT:
            return monitoringQueueEntryDetails.clientNegativeMediaCheckResult
              .client;
          case MONITORING_QUEUE_DETAILS_FOR_TYPES.WATCHLIST_MATCHES_LIST:
            return monitoringQueueEntryDetails.clientNegativeMediaCheckResult
              .client.watchListIgnoringProperties;
          default:
            return null;
        }
      }
      default:
        return null;
    }
  };

  const handleIgnoringPropertiesSubmit = (comment) => {
    const list = getDetails(
      MONITORING_QUEUE_DETAILS_FOR_TYPES.WATCHLIST_MATCHES_LIST,
    );
    const client = getDetails(MONITORING_QUEUE_DETAILS_FOR_TYPES.CLIENT);

    let shouldSubmit = false;
    const data = {};
    data.clientId = client.id;
    data.monitoringQueueEntryId = id;
    data.comment = comment;
    data.ignoringProperties = [];
    for (let i = 0; i < list.length; i += 1) {
      if (isNil(list[i].watchListSearchingDecisionDto)) {
        shouldSubmit = true;
        // break; // TEMP
      } else {
        shouldSubmit = true;
        data.ignoringProperties.push({
          type: list[i].watchListSearchingDecisionDto.type,
          watchListId: list[i].id,
        });
      }
    }
    if (shouldSubmit) {
      dispatch(createWatchListIgnoringProperty(data));
    }
  };

  const permitConfirmCheck = () => {
    const list = getDetails(
      MONITORING_QUEUE_DETAILS_FOR_TYPES.WATCHLIST_MATCHES_LIST,
    );

    let permit = false;
    if (list && list.length) {
      for (let i = 0; i < list.length; i += 1) {
        if (!isNil(list[i].watchListSearchingDecisionDto)) {
          permit = true;
          break;
        }
        permit = true;
      }
      setPermitConfirm(permit);
    } else {
      setPermitConfirm(permit);
    }
  };

  const showChangeStatusOption = () => {
    var result = true;
    if (
      monitoringQueueEntryDetails.type ===
        MONITORING_QUEUE_ENTRY_TYPES.API_SCORING ||
      monitoringQueueEntryDetails.type ===
        MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING ||
      monitoringQueueEntryDetails.type ===
        MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING
    ) {
      var list = [];

      switch (monitoringQueueEntryDetails.type) {
        case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH:
          list =
            monitoringQueueEntryDetails.clientManualSearchingResult
              .watchListMatchesList;
          break;
        case MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_REGULAR_SEARCH:
          list =
            monitoringQueueEntryDetails.clientRegularSearchingResult
              .watchListMatchesList;
          break;
        case MONITORING_QUEUE_ENTRY_TYPES.BATCH_SCORING:
        case MONITORING_QUEUE_ENTRY_TYPES.API_SCORING:
        case MONITORING_QUEUE_ENTRY_TYPES.REGULAR_SCORING:
          list =
            monitoringQueueEntryDetails.clientScoringResult
              .watchListMatchesList;
          break;
        case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO:
        case MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED:
          list = [monitoringQueueEntryDetails.clientNegativeMediaCheckResult];
          break;
        default:
      }

      if (list.length) {
        const haveDecision = list.every(
          (item) => item.watchListSearchingDecisionDto,
        );

        if (noneHaveDecision === undefined) {
          setNoneHaveDecision(!haveDecision);
        }
      }

      if (
        monitoringQueueEntryDetails.clientScoringResult
          .scoreCardRiskProfileValue === 5
      ) {
        if (list.length && isCoordinator) {
          const allHaveDecisionChecker = list.every(
            (item) => item.watchListSearchingDecisionDto,
          );
          // setAllHaveDecision used to check if coordinator can only escalate
          // used to pass the bool to the MonitoringQueueEntryScoringChangeStatusForm
          if (allHaveDecision === undefined) {
            setAllHaveDecision(allHaveDecisionChecker);
          }

          // result = allHaveDecisionChecker;
        }
      }
    }

    return result;
  };

  const getNegativeMediaUrl = (monitoringQueueEntryDetails) => {
    if (
      monitoringQueueEntryDetails.type ===
      MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO
    ) {
      return monitoringQueueEntryDetails.clientNegativeMediaCheckResult.url;
    }
    if (
      monitoringQueueEntryDetails.type ===
      MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
    ) {
      var data = JSON.parse(
        monitoringQueueEntryDetails.clientNegativeMediaCheckResult.dataJson,
      );
      if (data && data.Resolutions) {
        return data.Resolutions[0].ArticleUrl;
      }
    }
    return false;
  };

  const handleConfirm = (ignoringProperty) => {
    if (ignoringProperty.isNegativeIgnoringProp) {
      const data = {
        ...ignoringProperty,
        monitoringQueueEntryId: id,
      };

      delete data.isNegativeIgnoringProp;
      dispatch(createNegativeMediaIgnoringProperty(data));
    } else {
      if (
        ignoringProperty.type !==
        MONITORING_QUEUE_WATCHLIST_MATCH_STATUS_TYPES.INITIAL
      ) {
        const list = getDetails(
          MONITORING_QUEUE_DETAILS_FOR_TYPES.WATCHLIST_MATCHES_LIST,
        );
        list.find(
          // for request (not su sure, but in this mess...)
          (wm) => wm.id === ignoringProperty.id,
        ).watchListIgnoringProperty = { type: ignoringProperty.type };
        list.find(
          // for UI update
          (wm) => wm.id === ignoringProperty.id,
        ).watchListSearchingDecisionDto = { type: ignoringProperty.type };
      }
      permitConfirmCheck();
    }
  };

  return (
    <Container className="mt-2">
      <FullscreenLoader loading={isLoadingUpdateScoringResultStatus} />
      <Row>
        <Col lg={12}>
          {!isEmpty(monitoringQueueEntryDetails) &&
            !isNil(monitoringQueueEntryDetails) && (
              <MonitoringQueueEntryClientDetailsTable
                inputParams={getDetails(
                  MONITORING_QUEUE_DETAILS_FOR_TYPES.INPUT_PARAMS,
                )}
                client={getDetails(MONITORING_QUEUE_DETAILS_FOR_TYPES.CLIENT)}
                mqType={monitoringQueueEntryDetails.type}
                url={
                  monitoringQueueEntryDetails.type ===
                    MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO ||
                  monitoringQueueEntryDetails.type ===
                    MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED
                    ? getNegativeMediaUrl(monitoringQueueEntryDetails)
                    : false
                }
              />
            )}
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          {!isEmpty(monitoringQueueEntryDetails) &&
            !isNil(monitoringQueueEntryDetails) && (
              <MonitoringQueueEntrySearchDetailsForm
                handleSubmit={handleIgnoringPropertiesSubmit}
                details={monitoringQueueEntryDetails}
                handleConfirm={handleConfirm}
                permitConfirm={permitConfirm}
                setDataChange={setDataChange}
              />
            )}
        </Col>
      </Row>
      {monitoringQueueEntryDetails.type !==
        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO && (
        <Row>
          <Col lg={12}>
            {!isEmpty(monitoringQueueEntryDetails) &&
              !isNil(monitoringQueueEntryDetails) &&
              !isNil(monitoringQueueEntryDetails.clientScoringResult) &&
              !isNil(
                monitoringQueueEntryDetails.clientScoringResult
                  .detailedResultList,
              ) && (
                <MonitoringQueueEntryScoringDetailsTable
                  details={monitoringQueueEntryDetails}
                />
              )}
          </Col>
        </Row>
      )}
      {monitoringQueueEntryDetails.type !==
        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO &&
        monitoringQueueEntryDetails.type !==
          MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_ELASTIC_BASED && (
          <Row>
            <Col lg={12}>
              {showChangeStatusOption() && // HERE
                !isEmpty(monitoringQueueEntryDetails) &&
                !isNil(monitoringQueueEntryDetails) &&
                monitoringQueueEntryDetails.type > 2 &&
                monitoringQueueEntryDetails.clientScoringResult
                  .scoreCardRiskProfileValue === 5 && ( // High risk level === 5
                  <MonitoringQueueEntryScoringChangeStatusForm
                    handleSubmit={handleUpdateStatus}
                    clientScoringResult={
                      monitoringQueueEntryDetails.clientScoringResult
                    }
                    setDataChange={setDataChange}
                    allHaveDecision={allHaveDecision}
                    noneHaveDecision={noneHaveDecision}
                  />
                )}
            </Col>
          </Row>
        )}
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      {monitoringQueueEntryDetails.type !==
        MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO && (
        <SaveBeforeExit hasChanges={false} isRequired={false} />
      )}
    </Container>
  );
};

export default DetailsModalContent;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/details-modal/DetailsModalContent.jsx